import React from 'react';

import AdminPageContainer from './common/AdminPageContainer';
import AdminPageLink from './common/AdminPageLink';

const AdminPage = () => {
  return (
    <AdminPageContainer>
      <div className="is-flex is-flex-wrap">
        <AdminPageLink to="/admin/courses" text="Courses" />
        <AdminPageLink to="/admin/users" text="Users" />
        <AdminPageLink to="/admin/requests" text="Requests" />
        <AdminPageLink to="/admin/course-requests" text="Course Requests" />
        <AdminPageLink to="/admin/webinars" text="Webinars" />
      </div>
    </AdminPageContainer>
  );
};

export default AdminPage;
